<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
            <!-- //文本搜索内容 -->
            <div class="fun-panel fun-search-form-wrapper">
                <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="检查记录编号">
                                <a-input v-model="queryParams.jcjlbh" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="单据状态">
                                <FGDictSelect dictNo="JCGL100102" v-model="queryParams.djzt" placeholder="" mode="multiple" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="提交日期从">
                                <a-date-picker v-model="queryParams.tjrq_c" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="到">
                                <a-date-picker v-model="queryParams.tjrq_d" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="检查日期从">
                                <a-date-picker v-model="queryParams.jcrq_c" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="到">
                                <a-date-picker v-model="queryParams.jcrq_d" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <span class="fun-search-form-buttons" :style="{ float: 'right', overflow: 'hidden' }">
                                <a-button type="primary" @click="loadData" style="margin-right: 8px">查询</a-button>
                                <a-button @click="reset">重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </a-anchor>
        <div class="fun-panel">
            <a-spin :spinning="tableDataLoading">
                <vxe-toolbar
                    size="mini"
                    custom
                    :refresh="{
                        query: () => {
                            this.loadData();
                        }
                    }"
                >
                    <template v-slot:tools>
                        <a-radio-group style="margin-right: 15px" button-style="solid" v-model="queryParams.selType" @change="loadData">
                            <a-radio-button :value="0">
                                全部
                            </a-radio-button>
                            <a-radio-button :value="1">
                                待提交
                            </a-radio-button>
                            <a-radio-button :value="2">
                                已提交
                            </a-radio-button>
                        </a-radio-group>
                    </template>
                </vxe-toolbar>

                <vxe-table
                    ref="table"
                    size="mini"
                    resizable
                    row-id="id"
                    auto-resize
                    align="left"
                    :max-height="$FG_util.getTableHeightDirect(2)"
                    show-overflow="tooltip"
                    header-align="center"
                    :data="tableData"
                    highlight-hover-row
                    highlight-current-row
                    :sort-config="{
                        trigger: 'cell',
                        defaultSort: { field: sort.field, order: sort.order },
                        remote: true,
                        orders: ['asc', 'desc']
                    }"
                    @sort-change="handleSortChange"
                    @cell-dblclick="doubleClick"
                >
                    <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                    <vxe-table-column field="djzt" title="单据状态" width="80" align="center">
                        <template v-slot="{ row }">
                            <FGDictRenderer dictNo="JCGL100102" :value="row.djzt" />
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="jcjlbh" title="检查记录编号" width="150" align="center" sortable></vxe-table-column>
                    <vxe-table-column field="jcrq" title="检查日期" width="200" align="center"></vxe-table-column>
                    <vxe-table-column field="tbjzrq" title="填报截止日期" width="200" align="center"></vxe-table-column>
                    <vxe-table-column field="dwmc" title="单位名称" sortable></vxe-table-column>
                    <vxe-table-column field="tyshxydm" title="统一社会信用代码" align="center" sortable></vxe-table-column>
                    <vxe-table-column field="tjrq" title="提交日期" align="center" width="200"></vxe-table-column>
                    <vxe-table-column title="操作" align="center" width="200">
                        <template v-slot="{ row }">
                            <span class="btn_edit" v-if="row.djzt === 1 || row.djzt === 4" @click="detail(row, 1)">编辑</span>
                            <span class="btn_edit" v-if="row.djzt !== 1 && row.djzt !== 4" @click="detail(row, 2)">查看</span>
                        </template>
                    </vxe-table-column>
                </vxe-table>
                <vxe-pager
                    background
                    size="mini"
                    :current-page.sync="pageinfo.pageNo"
                    :page-size.sync="pageinfo.pageSize"
                    :total="pageinfo.total"
                    :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
                    @page-change="handlePageChange"
                >
                </vxe-pager>
            </a-spin>
        </div>
    </div>
</template>

<script>
export default {
    name: "ZjxxrkBrowse",
    components: {},
    data() {
        return {
            tableData: [], //表格数据
            queryParams: { selType: 1 },
            // 分页
            pageinfo: {
                pageNo: 1,
                pageSize: 20,
                total: 0
            },
            // 排序
            sort: {
                field: "jcjlbh",
                order: "desc"
            },
            tableDataLoading: false,
            isShow: false
        };
    },
    activated() {
        this.loadData(this.editDataId);
    },
    methods: {
        //双击事件
        doubleClick({ row }) {
            if (row.djzt === 1 || row.djzt === 4) {
                this.detail(row, 1);
            } else {
                this.detail(row, 2);
            }
        },
        //点击页码
        handlePageChange({ currentPage, pageSize }) {
            this.pageinfo.pageNo = currentPage;
            this.pageinfo.pageSize = pageSize;
            this.loadData();
        },
        //点击表头排序
        handleSortChange({ property, order }) {
            this.sort.field = property;
            this.sort.order = order;
            this.loadData();
        },
        //查询列表数据
        loadData(id) {
            // 如果没有指定选中记录则选中刷新前选中的记录
            if (!id) {
                let row = this.$refs.table.getCurrentRecord();
                if (row) {
                    id = row.id;
                }
            }
            this.tableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jcgl/jcqklr/list",
                    {
                        pageNo: this.pageinfo.pageNo,
                        pageSize: this.pageinfo.pageSize,
                        queryParams: this.queryParams,
                        sort: this.sort
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        this.tableData = data.data;
                        // 需要设置当前页，因为查询可能导致当前页发生变化
                        this.pageinfo.pageNo = data.pageinfo.pagenum;
                        this.pageinfo.total = data.pageinfo.maxrow;
                    } else {
                        // 数据加载失败清空表格
                        this.tableData = [];
                    }
                })
                .then(() => {
                    this.$nextTick(() => {
                        let row = null;
                        // 获取之前选择的记录
                        if (id) {
                            row = this.$refs.table.getRowById(id);
                        }
                        // 如果之前没有选择记录且表格不为空则选择第一条记录
                        if (!row && this.tableData.length > 0) {
                            row = this.$refs.table.getRowById(this.tableData[0].id);
                        }
                        if (row) {
                            // 设置当前记录
                            this.$refs.table.setCurrentRow(row);
                        } else {
                            // 清空当前行
                            this.$refs.table.clearCurrentRow();
                        }
                    });
                });
        },
        //重置文本内容
        reset() {
            this.queryParams = { selType: 1 };
        },
        // 详情页
        detail(row, state) {
            // 设置编辑记录id
            this.$emit("update:dataId", row.id);
            this.$emit("update:state", state);
            this.$emit("update:showPage", "JcqklrForm");
        }
    }
};
</script>
